import * as React from 'react';
import * as style from './Footer.css';
import {
  ArticleHeading1,
  ArticleHeading2,
  ArticleHeading3,
  ArticleHeading4,
  LinkButton,
  useDeviceType,
} from '@cian/ui-kit';
import classnames from 'classnames';

export const Footer: React.FC = () => {
  const isPhone = useDeviceType() === 'phone';

  const Title = isPhone ? ArticleHeading3 : ArticleHeading1;

  const SubTitle = isPhone ? ArticleHeading4 : ArticleHeading2;

  return (
    <footer className={style['container']}>
      <div className={classnames(style['wrapper'], isPhone && style['wrapper-phone'])}>
        <div className={style['telegram-info']}>
          <div className={style['title-tg']}>
            <Title fontWeight="500">Оставайтесь в курсе последних новостей рынка недвижимости!</Title>
          </div>
          <SubTitle fontWeight="500">
            Подписывайтесь на телеграм-канал для профессионалов{' '}
            <a
              className={style['link']}
              rel="noopener noreferrer"
              href="https://t.me/joinchat/U2Nv7QH1ivc0MDdi"
              target="_blank"
            >
              @cian_realtor
            </a>
          </SubTitle>
        </div>
        <div className={style['questions']}>
          <div className={style['title-questions']}>
            <Title fontWeight="500">Остались вопросы?</Title>
          </div>
          <div className={style['subtitle-questions']}>
            <SubTitle fontWeight="500">Напишите нам!</SubTitle>
          </div>
          <LinkButton
            href="https://www.cian.ru/contacts/"
            target="_blank"
            rel="noopener"
            size="M"
            theme="stroke_primary"
          >
            Написать
          </LinkButton>
        </div>
      </div>
    </footer>
  );
};
